export function searchFilterExpenses(expenses, searchTerm, stateFilter = "All", paymentFilter = "All") {
  if (!Array.isArray(expenses) || expenses.length === 0) return [];

  const term = (searchTerm || "")
    .replace(/[^a-zA-Z0-9\s\-_.]/g, "")
    .replace(/\s+/g, " ")
    .trim()
    .toLowerCase();

  const normalize = (v) => String(v || "").toLowerCase().replace(/[\s_-]+/g, "");

  return expenses.filter((exp) => {
    const matchesSearch =
      !term ||
      exp.referenceNumber?.toLowerCase().includes(term) ||
      exp.supplier?.toLowerCase().includes(term) ||
      exp.category?.toLowerCase().includes(term);

    const matchesState = stateFilter === "All" || normalize(exp.state) === normalize(stateFilter);

    const matchesPayment =
      paymentFilter === "All" || normalize(exp.paymentStatus) === normalize(paymentFilter);

    return matchesSearch && matchesState && matchesPayment;
  });
}

// Generic contains-any-field text filter for the simpler finance tables.
export function searchFilterByFields(rows, searchTerm, fields = []) {
  if (!Array.isArray(rows) || rows.length === 0) return [];

  const term = (searchTerm || "")
    .replace(/[^a-zA-Z0-9\s\-_.]/g, "")
    .replace(/\s+/g, " ")
    .trim()
    .toLowerCase();

  if (!term) return rows;

  return rows.filter((row) =>
    fields.some((field) => String(row?.[field] || "").toLowerCase().includes(term))
  );
}
